import { render, staticRenderFns } from "./SearchGoods.vue?vue&type=template&id=c522d2e8&scoped=true&"
import script from "./SearchGoods.vue?vue&type=script&lang=ts&"
export * from "./SearchGoods.vue?vue&type=script&lang=ts&"
import style0 from "./SearchGoods.vue?vue&type=style&index=0&id=c522d2e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522d2e8",
  null
  
)

export default component.exports